<template>
  <div>
    <collapse :multiple-active="false" :active-index="-1">
      <collapse-form-item
        id="fundCitationtStep"
        title="Fund Citation"
        @tabOpen="loadItem"
        :status="fundCitationStatus"
        v-bind:tabChange="getAllState.invoice"
        name="1"
      >
        <div>
          <fund-citation
            :is-read-only="isReadOnly"
            ref="fundCitationtStep"
            @validated="onSubStepValidated"
          ></fund-citation>
        </div>
      </collapse-form-item>
      <collapse-form-item
        id="AssignLineItemFundCitationStep"
        title="Assign Line Item(s) to Fund Citation"
        @tabOpen="loadItem"
        :status="lineItemInvoiceStatus"
        v-bind:tabChange="getAllState.invoice"
        name="2"
      >
        <div>
          <assign-line-item-fund-citation
            :is-read-only="isReadOnly"
            ref="AssignLineItemFundCitationStep"
            @validated="onSubStepValidated"
          ></assign-line-item-fund-citation>
        </div>
      </collapse-form-item>
      <collapse-form-item
        id="ReplacementFundCitationStep"
        title="Assign Replacement Line Item(s) to Fund Citation"
        @tabOpen="loadItem"
        :status="replacementItemInvoiceStatus"
        v-bind:tabChange="getAllState.invoice"
        name="2"
      >
        <div>
          <replacement-fund-citation
            :is-read-only="isReadOnly"
            ref="ReplacementFundCitationStep"
            @validated="onSubStepValidated"
          ></replacement-fund-citation>
        </div>
      </collapse-form-item>
      <collapse-form-item
        id="SupplyOfficialStep"
        title="Supplying/Invoicing Official (Signature)"
        @tabOpen="loadItem"
        :status="supplyOfficialStatus"
        name="3"
      >
        <div>
          <supply-official
            :is-read-only="isReadOnly"
            ref="SupplyOfficialStep"
            v-on:show-document-tab="showDocumentTab"
            @validated="onSubStepValidated"
          ></supply-official>
        </div>
      </collapse-form-item>
          <!-- option invoice module -->
      <collapse-form-item
        id="InvocieInformationStep"
        title="Invoice Information"
        @tabOpen="loadItem"
        :status="invoiceStatus"
        v-bind:tabChange="getAllState.invoice"
        name="3"
      >
        <div>
          <invoice-information
          :is-read-only="isReadOnly"
            ref="InvocieInformationStep"
            @validated="onSubStepValidated"
          ></invoice-information>
        </div>
      </collapse-form-item>
    </collapse>
  </div>
</template>

<script>
import FundCitation from "@/components/App/order/invoice/fundcitation/FundCitation.vue";
import AssignLineItemFundCitation from "@/components/App/order/invoice/assignlineitemfundcitation/AssignLineItemFundCitation.vue";
import ReplacementFundCitation from "@/components/App/order/invoice/replacementitemfundcitation/ReplacementFundCitation.vue";
import SupplyOfficial from "@/components/App/order/invoice/SupplyOfficial.vue";
import InvoiceInformation from './invoice/invoiceinformation/InvoiceInformation.vue';
import { Select, Option } from "element-ui";
import { BaseRadio, Collapse, CollapseFormItem } from "@/components/index";
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["isReadOnly"],
  name: "Invoice",
  components: {
    FundCitation,
    AssignLineItemFundCitation,
    SupplyOfficial,
    ReplacementFundCitation,
    Collapse,
    CollapseFormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseRadio,
    InvoiceInformation,
  },

  data() {
    return {
      status: false,
    };
  },
  mounted() {
    this.getFundCitationStatus(this.$route.params.id);
    this.getLineItemInvoiceStatus(this.$route.params.id);
    this.getReplacementItemInvoiceStatus(this.$route.params.id);
    this.getSupplyOfficialStatus(this.$route.params.id);
  },
  computed: {
    ...mapGetters({
      fundCitationStatus: "fundCitation/fundCitationStatus",
      lineItemInvoiceStatus: "lineItemInvoice/lineItemInvoiceStatus",
      replacementItemInvoiceStatus:"replacementItemInvoice/replacementItemInvoiceStatus",
      supplyOfficialStatus: "supplyOfficial/supplyOfficialStatus",
      orderStatus: "orderMetadata/orderStatus",
      invoiceStatus: "invoiceInformation/invoiceStatus",
      getAllState: "moduleState/getAllStates"
    }),
  },
  methods: {
    ...mapActions({
      getFundCitationStatus: "fundCitation/getFundCitationStatus",
      getLineItemInvoiceStatus: "lineItemInvoice/getLineItemInvoiceStatus",
      getReplacementItemInvoiceStatus: "replacementItemInvoice/getReplacementItemInvoiceStatus",
      getSupplyOfficialStatus: "supplyOfficial/getSupplyOfficialStatus",
      submitInvoice: "orderMetadata/submitInvoice",
    }),
    onSubStepValidated(validated, model) {
      this.$emit("on-validated", validated, model);
    },
    loadItem(ref, isOpen) {
      return this.$refs[ref].loaded();
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
    }
  },
};
</script>

<style scoped>
@import "../../../styles/custom_grid.css";

.card-collapse .card.card-plain.has-danger .card-header:after {
  background: #ec250d;
}

.card-collapse .card.card-plain.has-success .card-header:after {
  background: #10b45a;
}
</style>
